import { Controller } from 'stimulus'
import Sortable from 'sortablejs'

// Kanban drag & drop: each column body carries data-stage-id, each card data-opp-id.
export default class extends Controller {
  connect() {
    this.element.dataset.crmBoard = 'ready'
    this.element.querySelectorAll('.crm-column-body').forEach((col) => {
      Sortable.create(col, {
        group: 'crm',
        animation: 150,
        draggable: '.crm-card',
        // read-only cards (not owner) and signed/won cards can't be dragged…
        filter: '.crm-card--locked, .crm-card--done',
        preventOnFilter: false,        // …but their title link stays clickable
        ghostClass: 'crm-card--ghost',
        chosenClass: 'crm-card--chosen',
    // Released outside a column, the card snaps back instead of committing to the last hover.
        revertOnSpill: true,
        onEnd: (e) => this.persist(e)
      })
    })
  }

  persist(e) {
    if (e.from === e.to && e.oldIndex === e.newIndex) return
    // The card DOM node has already moved: tidy both columns optimistically.
    this.syncColumn(e.from)
    this.syncColumn(e.to)
    const id = e.item.dataset.oppId
    const stageId = e.to.dataset.stageId
    fetch(`/crm/opportunities/${id}/move`, {
      method: 'PATCH',
      headers: this.headers(),
      body: JSON.stringify({ stage_id: stageId })
    })
    // A deal dropped on the won stage becomes signed: reload so it re-renders as such.
      .then((r) => r.json())
      .then((data) => { if (data.status === 'won' || data.error) window.location.reload() })
      .catch(() => window.location.reload())
  }

  syncColumn(col) {
    if (!col) return
    const count = col.querySelectorAll('.crm-card').length
    col.querySelector('[data-crm-empty]')?.classList.toggle('hidden', count > 0)
    const badge = col.closest('[data-crm-lane]')?.querySelector('[data-crm-count]')
    if (badge) badge.textContent = count
  }

  archive(e) {
    const btn = e.currentTarget
    const id = btn.dataset.oppId
    const card = btn.closest('.crm-card')
    const col = card && card.closest('.crm-column-body')
    btn.disabled = true
    fetch(`/crm/opportunities/${id}/archive`, { method: 'PATCH', headers: this.headers() })
      .then((r) => r.json().catch(() => ({})).then((body) => ({ ok: r.ok, body })))
      .then(({ ok, body }) => {
      // A deal owned by someone else is refused: say so, or the button reads as doing nothing.
        if (!ok) { btn.disabled = false; if (body.error) window.alert(body.error); return }
        if (card) { card.style.transition = 'opacity .15s'; card.style.opacity = '0'; setTimeout(() => { card.remove(); this.syncColumn(col) }, 150) }
      })
      .catch(() => { btn.disabled = false })
  }

  headers() {
    const token = document.querySelector('meta[name="csrf-token"]')
    return {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'X-CSRF-Token': token ? token.content : ''
    }
  }
}
